/* src/app/components/ai-assist/autocomplete/autocomplete.component.scss */
#autocomplete-wrapper,
#autocomplete-input {
  width: 98%;
  position: relative;
  display: flex;
  flex-direction: column;
}
#autocomplete-wrapper .close,
#autocomplete-input .close {
  position: absolute;
  right: 30px;
  font-size: 14px;
  width: 32px !important;
  height: 32px;
  top: 4px;
  cursor: pointer;
}
.tags-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 5px;
  width: 100%;
  align-items: center;
  padding: 5px 0;
}
.tag {
  display: inline-flex;
  align-items: center;
  padding: 4px 8px 4px 12px;
  background-color: #C8E6C9;
  color: #424242;
  border-radius: 16px;
  font-size: 14px;
  line-height: 1.4;
  white-space: pre-wrap;
  max-width: 100%;
  height: 100%;
}
.tag-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  margin-left: 6px;
  background-color: #424242;
  color: white;
  border-radius: 50%;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  line-height: 1;
  flex-shrink: 0;
  transition: background-color 0.2s;
}
.tag-close:hover {
  background-color: #212121;
}
.search {
  z-index: 1000;
  cursor: pointer;
  background-color: #fff;
  font-family: sans-serif;
  opacity: 0.98;
  border-radius: 5px;
}
mark {
  background-color: transparent !important;
  font-weight: bold !important;
}
.search-result {
  padding: 4px 10px;
  font-size: 15px;
}
.search-result:first-child {
  border-left: 2px solid #133AA5;
}
.search-result:hover {
  background-color: #eceffe;
}
input {
  width: 100%;
  height: 40px;
  color: #111 !important;
  border: none;
  border-top-left-radius: 10px;
  margin-left: 0px;
  border-top-right-radius: 10px;
  padding: 0px 15px;
}
textarea {
  width: 98% !important;
  margin: auto;
  border: none !important;
  resize: none !important;
  margin: 5px;
  height: 75px;
  overflow-y: auto;
  background: transparent;
  color: #4b4b4b;
  font-size: 1.1rem !important;
}
input::placeholder,
textarea::placeholder {
  color: rgb(107, 107, 107) !important;
  text-transform: capitalize;
  font-size: 1.1rem !important;
}
#suggestion-list {
  width: inherit;
  font-size: 0.9rem !important;
  border-radius: 5px;
  box-shadow:
    rgba(0, 0, 0, 0.09) 0px 2px 1px,
    rgba(0, 0, 0, 0.09) 0px 2px 2px,
    rgba(0, 0, 0, 0.09) 0px 2px 4px,
    rgba(0, 0, 0, 0.09) 0px 2px 8px,
    rgba(0, 0, 0, 0.09) 0px 2px 5px;
  max-height: 200px;
  overflow-y: auto;
  position: absolute;
  z-index: 99;
  top: 43px;
}
#suggestion-list p {
  padding: 10px;
}
::-webkit-scrollbar {
  width: 3px;
}
::-webkit-scrollbar-track {
  background: #eee;
}
::-webkit-scrollbar-thumb {
  background: #eee;
}
::-webkit-scrollbar-thumb:hover {
  background: #eee;
}
.editable-input {
  min-height: 88px;
  max-height: 200px;
  overflow-y: auto;
  width: 100%;
  padding: 10px;
  font-size: 14px;
  white-space: pre-wrap;
}
/*# sourceMappingURL=autocomplete.component.css.map */
